import _capitalize from 'lodash.capitalize';

export function capitalize(value: string) {
  return _capitalize(value);
}
